import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";

import {
  GetSinglePraktikum,
  reset,
} from "../../../features/praktikum/PraktikumSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Alert,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";
import {
  GetAllJenisPembiayaanDropdown,
  reset as resetJenisPembiayaan,
} from "../../../features/jenisPembiayaanSlice";
import {
  GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID,
  reset as resetJenisPembiayaanDokumen,
} from "../../../features/jenisPembiayaanDokumenSlice";
import { 
  reset as resetSemester,
  GetConfigSemester, 
} from '../../../features/config/ConfigSemesterSlice';

import {
  faEdit,
  faEye,
  faTimesCircle,
} from "@fortawesome/free-regular-svg-icons";
import { faChevronCircleLeft, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalPraktikumTimeline from "../../../components/modal/ModalPraktikumTimeline/index";
import ModalVerificationDialog from "../../../components/modal/ModalVerificationDialog/index";
import {
  generateSemesterList,
  generateStudyYearsList,
} from "../../../helpers/helper";
import {
  GetAllKodePayDropdownPraktikum,
  reset as resetKodePayPraktikum,
} from "../../../features/kodepayVASlice";

const FormPembayaranVAPage = () => {
  const [dataPraktikum, setDataPraktikum] = useState({
    nim: "",
    nama: "",
  });
  const [dokumenList, setDokumenList] = useState([]);

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.praktikum);

  const {
    data: dataJenisPembiayaan,
    isLoading: isLoadingJenisPembiayaanList,
    isError: isErrorJenisPembiayaanList,
  } = useSelector((state) => state.jenisPembiayaan);

  const {
    data: dataJenisPembiayaanDokumen,
    isLoading: isLoadingJenisPembiayaanDokumenList,
    isError: isErrorJenisPembiayaanDokumenList,
  } = useSelector((state) => state.jenisPembiayaanDokumen);

  const {
    data: dataKodePayList,
    isLoading: isLoadingKodePayList,
    isError: isErrorKodePayList,
  } = useSelector((state) => state.kodepayVA);

  const { data: dataSemester, isLoading: isLoadingSemester } = useSelector(
    (state) => state.configSemester
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // reset to trigger update UI
    // because, there is a useEffect that relies to this props
    setDataPraktikum({
      nim: "",
      nama: "",
    });
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    dispatch(resetJenisPembiayaan());
    dispatch(resetJenisPembiayaanDokumen());
    dispatch(resetKodePayPraktikum());
    dispatch(resetSemester());
    dispatch(GetConfigSemester(token));
    dispatch(GetAllJenisPembiayaanDropdown({ token }));
    // // only cals the api when it is mahasiswa
    // if (userData?.id_role === "HA05") {
    //   dispatch(GetAllKodePayDropdownPraktikum(token));
    // }
    if (id) {
      dispatch(GetSinglePraktikum({ id, token }));
    }
  }, [id, dispatch, token, navigate]);

  // check if there is a change on userData
  useEffect(() => {
    // only cals the api when it is mahasiswa
    if (userData?.id_role === "HA05") {
      dispatch(GetAllKodePayDropdownPraktikum(token));
    }
  }, [id, navigate, dispatch, token, userData]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        nim: data?.data?.user?.nim || userData?.nim,
        nama: data?.data?.user?.nama || userData?.nama,
        id_jenis_pembiayaan: data?.data?.id_jenis_pembiayaan || userData?.id_jenis_pembiayaan,
        tahun_ajaran: id ? data?.data?.tahun_ajaran : getDataSemester() ? getDataSemester().period : null,
        jenis_semester: id ? data?.data?.jenis_semester : getDataSemester() ? getDataSemester().type : null,
      }
    );
    setDataPraktikum(copyData);
  }, [userData, data, dataSemester]);
  
  // UPDATE | 22/07/24 | the document has bind with the user now.
  useEffect(() => {
    const result = dataJenisPembiayaanDokumen?.data?.map((item, i) => ({
      id: item.id_user_dokumen,
      id_user: item.id_user,
      id_dokumen: item.id_dokumen,
      dokumen: item.dokumen,
      status: item.status,
      is_deleted: item.is_deleted,
      dokumenFullPath: item.dokumenFullPath,
    }));
    setDokumenList([...(result || [])]);
  }, [dataJenisPembiayaanDokumen]);

  useEffect(() => {
    dispatch(resetJenisPembiayaanDokumen());
    if (dataPraktikum?.id_jenis_pembiayaan) {
      dispatch(GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID({ token, id_jenis_pembiayaan: dataPraktikum?.id_jenis_pembiayaan, id_user: dataPraktikum?.id_user || userData?.id, }));
    }
  }, [dataPraktikum.id_jenis_pembiayaan]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // CHECK IF ALL THE DOKUMEN IS ALREADY UPLOADED
    const hasMandatoryEmpty = dataJenisPembiayaanDokumen?.data?.find(
      (e) =>
        e.is_mandatory &&
        !dokumenList?.find((el) => el.id_dokumen === e.id_dokumen)?.dokumen
    );
    if (hasMandatoryEmpty) {
      showFailedDialog({
        title: "Oops!",
        msg: "Harap upload semua data yang dibutuhkan!",
      });
      return;
    }

    // for now, the update system is unavailable.
    // this is just for preparing.
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          dataPraktikum.dokumen = dokumenList;
          if (id) {
            response = await axios.put(
              `${BASE_URL}praktikum/${id}`,
              {
                ...dataPraktikum,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}praktikum`,
              {
                ...dataPraktikum,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          const theID = response?.data?.data?.id;
          // if the id_jenis_pembiayaan from userData is null, then request to refresh the page.
          if (!userData.id_jenis_pembiayaan) {
            window.location.href = `/praktikum/detail/${theID}`;
          }
          // else just move to detail page
          else navigate(`/praktikum/detail/${theID}`);
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  function getJenisPembiayaanList() {
    try {
      const result = dataJenisPembiayaan?.data?.map((item, i) => ({
        value: item,
        label: item.nama,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  function getKodePayList() {
    try {
      const result = (dataKodePayList?.data || []).map((item, i) => ({
        value: item,
        label: item.deskripsi,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }
  
  function getDataSemester() {
    try {
      const result = dataSemester?.data[0];
      return result;
    } catch (error) {
      return null;
    }
  }

  // Function to update an item by ID
  const saveDokumenByIdDokumen = (id, newData) => {
    // check if the document is already save
    if (dokumenList.find((e) => e.id_dokumen === id)) {
      // Use map to create a new array with the updated item
      const updatedItems = dokumenList.map((dokumen) => {
        if (dokumen.id_dokumen === id) {
          dokumen = newData;
          // Return a new object with the updated ones
          return { ...dokumen };
        }
        // For other items, return them as they are
        return dokumen;
      });

      // Set the state with the updated items array
      setDokumenList(updatedItems);
    } else {
      setDokumenList([...dokumenList, newData]);
    }
  };

  // isRevised use by CREATOR who wants to resubmit their praktikum.
  const onAjukanClick = async (isRevised) => {
    const hasDokumenRevised = dokumenList?.find((e) => e.status === null || e.status === "2");
    if (isRevised) {
      if (hasDokumenRevised) {
        showFailedDialog({
          title: "Oops!",
          msg: "Mohon upload ulang file yang direvisi sebelum mengajukan ulang!",
        });
        return;
      }
    }
    showAlertDialog({
      title: isRevised ? "Ajukan Ulang?" : "Ajukan?",
      msg: `apakah anda yakin ingin mengajukan data ini?`,
      confirmButtonText: "Ajukan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          if (isRevised) {
            dataPraktikum.dokumen = dokumenList;
            await axios.post(
              `${BASE_URL}praktikum/ajukan_ulang/${id}`,
              {
                status: "1",
                id_kode_pay: dataPraktikum.id_kode_pay,
                dokumen: dokumenList,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            await axios.post(
              `${BASE_URL}praktikum/ajukan/${id}`,
              {
                ...dataPraktikum,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil mengajukan data!",
          });
          dispatch(reset());
          dispatch(GetSinglePraktikum({ id, token }));
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onFileChange = async (file, mDokumen) => {
    if (file) {
      try {
        showLoadingDialog();
        const formData = new FormData();
        formData.append("file", file); // 'file' should match the backend key that accepts the file

        // You can also append additional data to the FormData if needed
        const requestObj = {
          id_transaksi: `${userData.id}-${mDokumen.nama_dokumen}-${Date.now()}`,
          id_dokumen: mDokumen.id_dokumen,
          nama_dokumen: mDokumen.nama_dokumen,
        };

        Object.entries(requestObj).map(([key, value]) => {
          formData.append(`${key}`, `${value}`);
        });

        const response = await axios.post(
          `${BASE_URL}user/upload_file_user`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        saveDokumenByIdDokumen(mDokumen.id_dokumen, response?.data?.data);
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil menyimpan data!",
        });
      } catch (error) {
        console.log("ERROR", error);
        hideLoadingDialog();
        showFailedDialog({
          title: "Oops!",
          msg: error?.response?.data?.message || "Gagal menyimpan data!",
        });
      }
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[2] === "detail" ? (
        <>
          <Header title="Detail Praktikum">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/praktikum/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "create" ? (
        <>
          <Header title="Daftar Praktikum">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/praktikum/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "edit" ? (
        <>
          <Header title="Edit Praktikum">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/praktikum/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          dataPraktikum={dataPraktikum}
          setDataPraktikum={setDataPraktikum}
          dokumenList={dokumenList}
          handleSubmit={handleSubmit}
          formDisable={param.pathname.split("/")[2] === "detail" ? true : false}
          formDisableNotAdmin={userData?.id_role === "HA05"}
          onFileChange={onFileChange}
          onAjukanClick={onAjukanClick}
          isLoading={isLoading}
          isError={isError}
          isLoadingJenisPembiayaanList={isLoadingJenisPembiayaanList}
          dataJenisPembiayaan={getJenisPembiayaanList()}
          isLoadingJenisPembiayaanDokumenList={
            isLoadingJenisPembiayaanDokumenList
          }
          dataJenisPembiayaanDokumen={dataJenisPembiayaanDokumen}
          isLoadingDataKodePayList={isLoadingKodePayList}
          dataKodePayList={getKodePayList()}
          // semester
          isLoadingSemester={isLoadingSemester}
          dataSemester={getDataSemester()}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    id,
    isLoading,
    isError,
    dataPraktikum,
    setDataPraktikum,
    dokumenList,
    handleSubmit,
    formDisable,
    formDisableNotAdmin,
    onFileChange,
    onAjukanClick,
    // JenisPembiayaan
    isLoadingJenisPembiayaanList,
    dataJenisPembiayaan,
    // Kategori JenisPembiayaan
    isLoadingJenisPembiayaanDokumenList,
    dataJenisPembiayaanDokumen,
    // Kodepay Matkul Praktikum
    isLoadingDataKodePayList,
    dataKodePayList,
    // data semester
    isLoadingSemester,
    dataSemester,
  } = props;

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const [showModalTimeline, setShowModalTimeline] = useState(false);
  const [showVerifModal, setShowVerifModal] = useState(false);

  const onClickVerify = async (status_approval, catatan) => {
    showLoadingDialog();
    try {
      if (id) {
        const response = await axios.post(
          `${BASE_URL}praktikum/verifikasi/${id}`,
          {
            status_approval,
            catatan,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        hideLoadingDialog();
        showSuccessDialog({
          title: "Berhasil!",
          msg: "Berhasil memverifikasi data!",
        });
        // refetch
        setShowVerifModal(false);
        dispatch(reset());
        dispatch(GetSinglePraktikum({ id, token }));
      } else {
        throw "id not found!";
      }
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal memverifikasi data!",
      });
    }
  };

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : isError ? (
        <p>Oops, something went wrong!</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {/* Show when the status_verifikasi is not 1, means it is revised or rejected */}
            {formDisable &&
            (dataPraktikum.status_verifikasi === "2" ||
              dataPraktikum.status_verifikasi === "3") ? (
              <Col md={12} className="mb-3">
                <Card bg="danger" text="white">
                  <Card.Header>Balasan Pengajuan</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={12} className="mb-3">
                        <Form.Group id="balasan">
                          <Form.Label>Balasan</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="-"
                            name="balasan"
                            disabled={true}
                            value={
                              dataPraktikum.status_verifikasi === "2"
                                ? "Revisi"
                                : "Ditolak"
                            }
                          />
                        </Form.Group>
                      </Col>
                      {formDisable &&
                      dataPraktikum.catatan &&
                      dataPraktikum.status_verifikasi === "2" ? (
                        <Col md={12}>
                          <Form.Group id="catatan">
                            <Form.Label>Catatan</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder="-"
                              name="catatan"
                              disabled={true}
                              value={dataPraktikum.catatan}
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}
            {formDisable && dataPraktikum.nomor_praktikum ? (
              <Col md={12} className="mb-3">
                <Form.Group id="nomor_praktikum">
                  <Form.Label>Nomor Praktikum</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="nomor_praktikum"
                    name="nomor_praktikum"
                    disabled={true}
                    value={dataPraktikum.nomor_praktikum || ""}
                  />
                </Form.Group>
              </Col>
            ) : null}
            <Col md={12} className="mb-3">
              <Form.Group id="nim">
                <Form.Label>NIM</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="NIM"
                  name="nim"
                  disabled={formDisable || formDisableNotAdmin}
                  value={dataPraktikum.nim || ""}
                  onChange={(e) =>
                    setDataPraktikum({
                      ...dataPraktikum,
                      nim: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={formDisable || formDisableNotAdmin}
                  value={dataPraktikum.nama || ""}
                  onChange={(e) =>
                    setDataPraktikum({
                      ...dataPraktikum,
                      nama: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            {
              // if the user is not admin
              !formDisableNotAdmin ?
              <Col md={12} className="mb-3">
                <Form.Group id="matkul_praktikum">
                  <Form.Label>Matkul Praktikum</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Matkul praktikum"
                    name="matkul_praktikum"
                    disabled
                    value={dataPraktikum.matkul_praktikum || ""}
                  />
                </Form.Group>
              </Col> :
              <Col md={12} className="mb-3">
                <Form.Group id="matkul_praktikum">
                  <Form.Label>Matkul Praktikum</Form.Label>
                  <Select
                    options={dataKodePayList}
                    placeholder="Pilih matkul praktikum"
                    value={dataKodePayList?.find(
                      (e) => e.value.id === dataPraktikum.id_kode_pay
                    )}
                    required
                    isDisabled={formDisable}
                    isLoading={isLoadingDataKodePayList}
                    onChange={(e) => {
                      setDataPraktikum({
                        ...dataPraktikum,
                        matkul_praktikum: e.value.deskripsi,
                        id_kode_pay: e.value.id,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
            }
            {isLoadingSemester ? null : (
              <>
                <Col md={12} className="mb-3">
                  <Form.Group id="tahun_ajaran">
                    <Form.Label>Tahun Ajaran</Form.Label>
                    <Select
                      options={generateStudyYearsList()}
                      placeholder="Pilih tahun ajaran"
                      value={generateStudyYearsList()?.find(
                        (e) => e.value === dataPraktikum.tahun_ajaran
                      )}
                      required
                      isDisabled={formDisable || dataSemester}
                      onChange={(e) => {
                        setDataPraktikum({
                          ...dataPraktikum,
                          tahun_ajaran: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group id="jenis_semester">
                    <Form.Label>Semester</Form.Label>
                    <Select
                      options={generateSemesterList()}
                      placeholder="Pilih semester"
                      value={generateSemesterList()?.find(
                        (e) => e.value === dataPraktikum.jenis_semester
                      )}
                      required
                      isDisabled={formDisable || dataSemester}
                      onChange={(e) => {
                        setDataPraktikum({
                          ...dataPraktikum,
                          jenis_semester: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            <Col md={12} className="mb-3">
              <Form.Group id="id_jenis_pembiayaan">
                <Form.Label>Kategori Jenis Pembiayaan</Form.Label>
                <Select
                  options={dataJenisPembiayaan}
                  placeholder="Pilih jenis pembiayaan"
                  required
                  value={dataJenisPembiayaan?.find(
                    (e) => e.value.id === dataPraktikum?.id_jenis_pembiayaan
                  )}
                  isDisabled={formDisable || userData?.id_jenis_pembiayaan}
                  isLoading={isLoadingJenisPembiayaanList}
                  onChange={(e) => {
                    setDataPraktikum({
                      ...dataPraktikum,
                      id_jenis_pembiayaan: e.value.id,
                    });
                  }}
                />
              </Form.Group>
            </Col>
            {isLoadingJenisPembiayaanDokumenList ? (
              <Col md={12} className="mb-3">
                <p>Loading...</p>
              </Col>
            ) : (
              (dataJenisPembiayaanDokumen?.data || []).map((item, i) => {
                const dataDokumen = dokumenList.find(
                  (e) => e.id_dokumen === item.id_dokumen
                );
                return (
                  <UploadComponent
                    key={i}
                    item={item}
                    dataDokumen={dataDokumen}
                    onFileChange={onFileChange}
                    formDisable={formDisable}
                    dataPraktikum={dataPraktikum}
                    userData={userData}
                  />
                );
              })
            )}
            {formDisable && dataPraktikum?.user?.no_hp ? (
              <Col md={12} className="mb-3">
                <Form.Group id="no_hp">
                  <Form.Label>No. Handphone</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="no_hp"
                    disabled={true}
                    value={dataPraktikum?.user?.no_hp || "-"}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataPraktikum.created_at ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataPraktikum.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable &&
            dataPraktikum.verified_at &&
            dataPraktikum.status === "5" ? (
              <Col md={12} className="mb-3">
                <Form.Group id="verified_at">
                  <Form.Label>Tanggal Disetujui</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="verified_at"
                    disabled={true}
                    value={moment(dataPraktikum.verified_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
          {formDisable ? (
            <div className="d-grid gap-2">
              {
                // check if the data is on approval request or it is already revised
                // and make sure the data isn't rejected by checking it's last verification
                dataPraktikum.status_verifikasi !== "3" &&
                ((userData?.id_role === dataPraktikum.role_status &&
                  !dataPraktikum.flag_revisi) ||
                  (dataPraktikum.flag_revisi &&
                    userData?.id === dataPraktikum.id_user)) ? (
                  <>
                    <Button
                      disabled={isLoading}
                      onClick={() =>
                        userData?.id !== dataPraktikum.id_user
                          ? setShowVerifModal(true)
                          : onAjukanClick(dataPraktikum.flag_revisi)
                      }
                    >
                      {userData?.id === dataPraktikum.id_user
                        ? dataPraktikum.flag_revisi
                          ? "Ajukan Ulang Praktikum"
                          : `Ajukan Praktikum`
                        : "Verifikasi"}
                    </Button>
                    <ModalVerificationDialog
                      show={showVerifModal}
                      onClose={() => setShowVerifModal(false)}
                      cb={(status, reason) => onClickVerify(status, reason)}
                    />
                  </>
                ) : null
              }
              {/* TIMELINE BUTTON */}
              {dataPraktikum.status !== "0" ? (
                <>
                  <Button
                    disabled={isLoading}
                    variant="outline-primary"
                    onClick={() => setShowModalTimeline(true)}
                  >
                    Lihat Timeline
                  </Button>
                  <ModalPraktikumTimeline
                    id={id}
                    show={showModalTimeline}
                    onHide={() => setShowModalTimeline(false)}
                  />
                </>
              ) : null}
            </div>
          ) : (
            <div>
              {id ? (
                <Button type="submit" disabled={isLoading}>
                  Update
                </Button>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  Simpan
                </Button>
              )}
            </div>
          )}
        </Form>
      )}
    </Card.Body>
  );
};

const UploadComponent = ({
  item, // data from the master
  dataDokumen, // data document that we have store into our system
  onFileChange,
  formDisable,
  dataPraktikum, // data from praktikum
  userData,
}) => {
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const isAbleToReject =
    userData?.id_role === dataPraktikum.role_status &&
    dataPraktikum.flag_revisi;

  function isDisableForm() {
    let result = true;
    if (formDisable) {
      // check untuk mahasiswa
      if (
        userData?.id_role === "HA05"
        && dataPraktikum?.status === "1" 
        && dataPraktikum.flag_revisi
        && (
          dataDokumen?.status === null 
          || dataDokumen?.status === "2"
        )
      ) {
        result = false;
      }
      // check untuk staff
      else if (isAbleToReject) {
        // disable if the dokumen is already rejected
        if (dataDokumen?.status === null || dataDokumen?.status === "2") result = true;
        // make it false when it hasn't rejected yet
        else result = false;
      }
      // // if there is no condition to update a file.
      // // make it true;
      // else {
      //   result = true;
      // }
    } else {
      result = false;
    }
    return result;
  }

  const revisedDokumen = () => {
    showAlertDialog({
      title: "Perlu Revisi?",
      msg: `apakah anda yakin ingin menandai revisi pada dokumen ini?`,
      confirmButtonText: "Revisi",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          await axios.post(
            `${BASE_URL}praktikum/verifikasi_perdokumen`,
            {
              id: dataDokumen.id,
              status: "2", // revised
            },
            {
              headers: {
                Authorization: token,
              },
            }
          );
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menandai data!",
          });
          dispatch(reset());
          dispatch(GetSinglePraktikum({ id: dataPraktikum.id, token }));
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menandai data!",
          });
        }
      },
    });
  };

  return (
    <Col md={12} className="mb-3">
      <Form.Group controlId="formFile">
        <Form.Label>
          {item.nama_dokumen}
          <span style={{ color: "red" }}>{item.is_mandatory ? "*" : ""}</span>
        </Form.Label>
        {`${dataPraktikum?.status}` === "1" && `${dataDokumen?.status}` === "2" ? (
          <Alert sm="true" variant="danger">
            File telah ditolak, mohon upload ulang dengan data yang sesuai!
          </Alert>
        ) : null}
        <Row>
          <Col>
            <Form.Control
              required
              type="text"
              placeholder="Pilih file untuk diupload"
              name="dokumen"
              disabled={true}
              value={dataDokumen?.dokumen || ""}
            />
          </Col>
          <Col xs="auto">
            <Form.Control
              ref={fileInputRef}
              onChange={(event) => onFileChange(event.target.files[0], item)}
              type="file"
              className="d-none"
              // disable when the form is disable and the document is not rejected
              disabled={isDisableForm()}
              accept=".pdf,.jpg,.jpeg,.png"
            />
            <Button
              variant={
                isAbleToReject && dataDokumen?.status === "0"
                  ? "danger"
                  : "primary"
              }
              // disable when the form is disable and the document is not rejected
              disabled={isDisableForm()}
              onClick={() => {
                if (isAbleToReject) {
                  revisedDokumen();
                } else {
                  fileInputRef.current.click();
                }
              }}
            >
              <FontAwesomeIcon
                icon={
                  isAbleToReject
                    ? faTimesCircle
                    : dataDokumen?.dokumenFullPath
                    ? faEdit
                    : faUpload
                }
              />
            </Button>
          </Col>
          {dataDokumen?.dokumenFullPath ? (
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={() => openLink(dataDokumen?.dokumenFullPath)}
              >
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </Col>
          ) : null}
        </Row>
      </Form.Group>
    </Col>
  );
};

export default FormPembayaranVAPage;
